import {component} from '../form/Constant'

export const severityNotification = {
    success: 'success',
    info: 'info',
    warn: 'warn',
    error: 'error',
}
export const summaryNotification = {
    success: 'Success',
    information: 'Information',
    warning: 'Warning',
    error: 'Error',
}

export const notificationSettingKeys = {
    // Hospital Information
    hospitalInformation: 'hospitalInformation',
    hospitals: 'hospitals',

    // Patient Pre-condition
    staticLists: 'staticLists',
    pathways: 'pathways',

    // Health Criteria
    healthCriteriaList: 'healthCriteriaList',
    healthAssessmentParameters: 'healthAssessmentParameters',

    // Patient Information
    patientList: 'patientList',
    patients: 'patients',

    // Additional Notify Methods
    additionalNotifyMethod: 'additionalNotifyMethod',
    otherMethodsType: 'otherMethodsType',
    otherMethods: 'otherMethods',
}

export const notifyMethodTypeKeys = {
    sms: 'sms',
    email: 'email',
}

export const notifyMethodOptions = [
    {
        value: notifyMethodTypeKeys.sms,
        label: 'SMS',
    },
    {
        value: notifyMethodTypeKeys.email,
        label: 'Email',
    },
]

export const healthCriteriaKeys = {
    news: 'news',
    fall: 'fall',
    emergency: 'emergency',
    symptom: 'symptom',
    conversation: 'conversation',
    ecg: 'ecg',
}

export const NotificationTypes = {
    FALL: 'fall',
    NEWS: 'news',
    TAS: 'tas',
    EMERGENCY: 'emergency',
    SEIZURE: 'seizure',
    ECG: 'ecg',
    SYMPTOM: 'symptom',
    CONVERSATION: 'conversation',
}

export const NotificationStatus = {
    read: 'read',
    unseen: 'unseen',
    discarded: '',
}

export const healthCriteriaDataList = [
    {
        label: 'NEWS2',
        value: 'news',
    },
    {
        label: 'FALL',
        value: 'fall',
    },
    {
        label: 'Emergency',
        value: 'emergency',
    },
    {
        label: 'Symptom Report',
        value: 'symptom',
    },
    {
        label: 'Conversations',
        value: 'conversation',
    },
    {
        label: 'ECG',
        value: 'ecg',
    },
]

export const healthAssessmentList = [
    {
        label: 'SpO2',
        value: 'oxygen',
    },
    {
        label: 'Heart Rate',
        value: 'heartRate',
    },
    {
        label: 'Respiration',
        value: 'respiration',
    },
    {
        label: 'Temperature',
        value: 'temperature',
    },
    {
        label: 'Blood Pressure',
        value: 'bloodPressure',
    },
    {
        label: 'Level Of Consciousness',
        value: 'levelOfConsciousness',
    },
    {
        label: 'Glucose',
        value: 'glucose',
    },
]

export const healthAssessmentEmergencyList = [
    {
        label: 'SpO2',
        value: 'oxygen',
    },
    {
        label: 'Heart Rate',
        value: 'heartRate',
    },
    {
        label: 'Respiration',
        value: 'respiration',
    },
    {
        label: 'Temperature',
        value: 'temperature',
    },
    {
        label: 'Blood Pressure',
        value: 'bloodPressure',
    },
    {
        label: 'Level Of Consciousness',
        value: 'levelOfConsciousness',
    },
    {
        label: 'Glucose',
        value: 'glucose',
    },
    {
        label: 'Steps',
        value: 'steps',
    },
    {
        label: 'Sleep',
        value: 'sleep',
    },
]

export const notificationSettingDataList = [
    {
        key: notificationSettingKeys.hospitalInformation,
        description: 'Select hospitals information',
        children: [
            {
                key: notificationSettingKeys.hospitals,
                placeholder:
                    'Select hospitals you want to see patient notifications',
                component: component.multiSelect,
                options: [],
            },
            {
                key: notificationSettingKeys.staticLists,
                placeholder:
                    'Select static list you want to see patient notifications',
                component: component.multiSelect,
                options: [],
            },
            {
                key: notificationSettingKeys.pathways,
                placeholder:
                    'Select pathways you want to see patient notifications',
                component: component.multiSelect,
                pathway: true,
                options: [],
            },
            {
                key: notificationSettingKeys.healthCriteriaList,
                placeholder:
                    'Select health criteria you want to see patient notifications',
                component: component.multiSelect,
                options: healthCriteriaDataList,
            },
        ],
    },
    {
        key: notificationSettingKeys.patientList,
        description: 'Select patients you want to see notification',
        children: [
            {
                key: notificationSettingKeys.patients,
                placeholder: 'Select patients you want to see notification',
                component: component.multiSelect,
                options: [],
            },
        ],
    },
]
